import React from 'react';
import { FadeIn, Section, SectionLabel } from './UI';
export const ProblemSection = () => {
  return <>
      <Section className="bg-brand-grayBg" data-id="element-77">
        <FadeIn data-id="element-78">
          <SectionLabel data-id="element-79">¿Te suena familiar?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-80">
            Llevas semanas buscando.
            <br data-id="element-81" />
            <span className="text-brand-purple" data-id="element-82">
              Y aún no has dado el primer paso.
            </span>
          </h2>
          <p className="mb-4 text-[1.05rem]" data-id="element-83">
            Has visto videos. Has leído artículos. Has preguntado en grupos. Y
            aun así…
          </p>

          <ul className="my-[30px]" data-id="element-84">
            {['No sabes exactamente por qué pasos empezar ni en qué orden', 'No estás seguro de qué tipo de empresa registrar para tu situación', 'Tienes miedo de cometer un error que te cueste caro — tiempo o dinero', 'Cada respuesta que encuentras genera tres preguntas nuevas', 'Sientes que el proceso es más complicado de lo que debería ser'].map((item, i) => <li key={i} className="py-[14px] border-b border-brand-border text-[1.05rem] flex items-start gap-3" data-id="element-85">
                <span className="text-brand-pink font-bold text-[1.1rem] shrink-0 mt-[2px]" data-id="element-86">
                  ✗
                </span>
                {item}
              </li>)}
          </ul>

          <div className="bg-brand-purple text-brand-white rounded-2xl py-8 px-9 mt-[30px] text-[1.2rem] italic leading-[1.6] text-center" data-id="element-87">
            <strong className="text-brand-pink font-bold" data-id="element-88">
              El problema no es que falte información.
            </strong>
            <br data-id="element-89" />
            El problema es que hay demasiada — y ninguna te la da en orden, con
            los errores reales, para tu situación específica.
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-white" data-id="element-90">
        <FadeIn data-id="element-91">
          <SectionLabel data-id="element-92">Por qué los métodos comunes no funcionan</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-93">
            No es tu culpa que
            <br data-id="element-94" />
            <span className="text-brand-purple" data-id="element-95">sigas paralizado.</span>
          </h2>
          <p className="mb-4 text-[1.05rem]" data-id="element-96">
            Los métodos que la mayoría usa están diseñados para informar — no
            para que ejecutes.
          </p>

          <div className="overflow-x-auto mt-8" data-id="element-97">
            <table className="w-full border-collapse text-[0.97rem]" data-id="element-98">
              <thead data-id="element-99">
                <tr className="bg-brand-purple text-brand-white" data-id="element-100">
                  <th className="py-4 px-5 text-left font-semibold" data-id="element-101">
                    Método Común
                  </th>
                  <th className="py-4 px-5 text-left font-semibold" data-id="element-102">
                    Por Qué Falla
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-103">
                <tr className="bg-brand-grayBg" data-id="element-104">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-105">
                    🔍 Buscar en Google
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-106">
                    Información fragmentada, desactualizada, sin orden y
                    genérica
                  </td>
                </tr>
                <tr data-id="element-107">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-108">
                    📺 Videos de YouTube
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-109">
                    Sin secuencia, no cubren tu caso, y evitan los errores
                    reales
                  </td>
                </tr>
                <tr className="bg-brand-grayBg" data-id="element-110">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-111">
                    👥 Grupos de Facebook
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-112">
                    Opiniones contradictorias de personas que tampoco lo
                    hicieron bien
                  </td>
                </tr>
                <tr data-id="element-113">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-114">
                    💸 Contratar sin entender
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-115">
                    Gastas sin saber qué compraste ni si lo estás haciendo
                    correcto
                  </td>
                </tr>
                <tr className="bg-brand-grayBg" data-id="element-116">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-117">
                    ✅ <strong data-id="element-118">Ruta USA 360</strong>
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-brand-purple font-semibold" data-id="element-119">
                    Proceso completo · En orden · Con los errores que debes
                    evitar
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </FadeIn>
      </Section>
    </>;
};